import React from 'react';
import Banner from './Banner';

export const VOTING_HEADER =
    'It’s National Voter Registration Day on Sept. 28! Are you registered?';

interface VotingBannerProps {
    handleTracking?: Function;
    trackingParams?: string;
    category?: string;
}

const VotingBanner: React.FunctionComponent<VotingBannerProps> = (props) => {
    const trackingData = {
        type: 'TRACK_VOTING_BANNER_CLICK',
        meta: {
            analytics: {
                action: 'VotingBannerClick',
                category: props.category,
            },
        },
    };

    const destinationURL = 'https://headcount.turbovote.org/?r=eventbrite';

    return (
        <Banner leftAccentColor="#F05537" style="" header={VOTING_HEADER}>
            <span>
                We partnered with HeadCount to help you get registered to vote
                (or check your status)!{' '}
                <a
                    onClick={() => {
                        props.handleTracking?.(trackingData);
                    }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={destinationURL}
                >
                    Register to vote
                </a>
                .
            </span>
        </Banner>
    );
};

export default VotingBanner;
